module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_23.151d864f.mp3";